import React from 'react';

function ContactInfo() {
  return (
    <div className="info">
      <div className="card info-card">
        <div className="info-row">
          <div className="info-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z" />
              <path d="M22 7l-10 6L2 7" />
            </svg>
          </div>
          <div>
            <div className="lbl">Email</div>
            <div className="val">hello@nurturer.ai</div>
          </div>
        </div>
        <div className="info-row">
          <div className="info-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 21h18" />
              <path d="M5 21V7l8-4v18" />
              <path d="M19 21V11l-6-3" />
            </svg>
          </div>
          <div>
            <div className="lbl">Office</div>
            <div className="val">
              6751 Columbia Gateway Drive,
              <br />
              Suite 300, Columbia, MD 21046
            </div>
          </div>
        </div>
        <div className="info-row">
          <div className="info-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22a10 10 0 100-20 10 10 0 000 20z" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
          <div>
            <div className="lbl">Response time</div>
            <div className="val">Within 1 business day</div>
          </div>
        </div>
      </div>

      <div className="card demo-card">
        <h3>Prefer a live demo?</h3>
        <p>
          See Nurturer drafting real touches against your pipeline in a quick 20-minute walkthrough.
        </p>
        <a className="btn btn-cream" href="#top">
          Book a demo
        </a>
      </div>
    </div>
  );
}

export default ContactInfo;
